import React, { useContext } from 'react';
import { Section, SkeletonHeadingItem } from '@atlaskit/menu';
import { PeopleMenuContext } from '../../context/PeopleMenuContext';
import LoadingSkeletonItem from './LoadingSkeletonItem';
export const MenuGroupSection = ({
  title,
  isEmpty,
  isLoading,
  children,
  testId,
  maxItems,
  sectionType
}) => {
  const {
    isSectionList = false
  } = useContext(PeopleMenuContext);
  if (!isLoading && isEmpty) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Section
  // title is undefined if we are loading as we show the heading skeleton below
  , {
    title: isLoading ? undefined : title,
    testId: testId,
    isList: isSectionList
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SkeletonHeadingItem, {
    testId: `${sectionType}-skeleton-heading`
  }), Array(maxItems).fill(undefined).map((_, index) => /*#__PURE__*/React.createElement(LoadingSkeletonItem, {
    key: `${sectionType}-${index}`
  }))) : children);
};